<style>
    .print-journey-page .show-journey-buttons{
        display: none;
    }
</style>
<template>
    <div class="row">
        <div class="col-12" v-if="!selectedStage.position">
            <div class="journey-page">
                <div class="container">
                    <div class="navbar navbar-light d-print-block bg-white mt-3 px-4">
                        <a class="navbar-brand" href="#">
                            <img src="/img/logo-full.png" alt />
                        </a>
                    </div>
                </div>
                <div class="container">
                    <div id="details" class="row my-4 journey-details scroll-offset details" ref='details'>
                        <div class="col-12">
                            <h1>Journey Details</h1>
                            <div class="row" v-if="isLoading">
                                <div class="col-12 min-height-500 text-center p-5 d-flex justify-content-center align-items-center">
                                    <div class="spinner-border m-5 p-3" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <print-journey-details v-if="currentJourney" :journey="currentJourney" :showingReturn="showingReturn" @toggleJourneyType="showingReturn = !showingReturn"></print-journey-details>
                    </div>
                    <div class="row mt-5 map-of-journey scroll-offset" ref='map'>
                    </div>
                    <div class="row">
                        <div class="col-12 mt-5 steps-journey scroll-offset" ref='stepByStep'>
                            <h1>Step-by-step guide</h1>
                            <div class="row" v-if="isLoading">
                                <div class="col-12 min-height-500 text-center p-5 d-flex justify-content-center align-items-center">
                                    <div class="spinner-border m-5 p-3" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isLoading" class="row">
                                <div class="col-12 mb-3">
                                    <hr>
                                </div>
                                <div class="col-12">
                                    <print-step v-for="(step, index) in steps" :key="index"
                                        v-show="step.show_as !== 'hidden'"
                                        :journey="currentJourney"
                                        :step="step.step"
                                        :showAs="step.show_as"
                                        :hours="selectedTime"
                                        :position="step.position" @show="showSteps(step.journey_type)" @showDetails="showDetails(step, index)">
                                    </print-step>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import PrintJourneyDetails from '@/components/PrintJourneyDetails.vue'
// import JourneyMap from '@/components/JourneyMap.vue'
// import StageDetails from '@/components/StageDetails.vue'
import PrintStep from '@/components/PrintStep.vue'
import moment from 'moment'

import {
    mapGetters, mapActions, mapState, mapMutations,
} from 'vuex'
import mutationsMapping from '@/store/mutations-mapping'

export default {
    name: 'journey',
    components: {
        PrintJourneyDetails,
        // JourneyMap,
        PrintStep,
        // StageDetails,
    },
    data() {
        return {
            journey: {},
            selected: '',
            viewing: 'details',
            selectedStage: {},
            selectedStageIndex: null,
            showingMap: 'depart',
            showDepartStepsOffset: 1000,
            showReturnStepsOffset: 1000,
            hasChanged: false,
            showingReturn: true,
            option: {
                hours: [
                    { label: '30 minutes', value: 30, disabled: false },
                    { label: '1 hour', value: 60, disabled: false },
                    { label: '1 hour 30', value: 90, disabled: false },
                    { label: '2 hours', value: 120, disabled: false },
                    { label: '2 hours 30', value: 150, disabled: false },
                    { label: '3 hours', value: 180, disabled: false },
                ],
            },
            selectedTime: { label: '1 hour', value: '1 hr', disabled: false },
            crumbs: [
                {
                    text: 'Plan your journey',
                    to: { name: 'Home' },
                },
                {
                    text: 'Select journey option',
                    to: { name: 'Results' },
                },
                {
                    text: 'Journey details',
                    active: true,
                },
            ],
            hash: this.$route.params.hash,
            form: {
                origin: this.origin,
                destination: this.destination,
                arrive_time: this.arriveDateAndTime,
                return_time: '',
                has_access_to_car: this.hasAccessToCar,
                has_concessionary_pass: this.hasConcessionaryPass,
                has_railcard: !!this.railcardType,
                railcard_type: this.railcardType,
                arrive_by_buffer: '30',
            },
        }
    },
    mounted() {
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },
    computed: {
        ...mapGetters([
            'getJourneyById',
        ]),
        ...mapState([
            'currentJourney',
            'isLoading',
            'origin',
            'destination',
            'arriveDate',
            'arriveTime',
            'arriveDateAndTime',
            'railcardType',
            'hasAccessToCar',
            'hasConcessionaryPass',
        ]),
        steps() {
            const steps = []

            if (!this.currentJourney) {
                return steps
            }

            const departStepsLength = this.currentJourney.depart.steps.length
            for (let i = 0; i < departStepsLength; i += 1) {
                const step = this.currentJourney.depart.steps[i]
                const stepsToCollapse = departStepsLength - i - this.showDepartStepsOffset + 1
                const isLastStep = departStepsLength === (i + 1)
                let position = 'middle'

                if (this.showDepartStepsOffset > i && !isLastStep) {
                    if (i === 0) {
                        position = 'first'
                    }
                    steps.push({
                        show_as: 'step',
                        step,
                        position,
                        journey_type: 'depart',
                    })
                } else if (isLastStep) {
                    steps.push({
                        show_as: 'step',
                        step,
                        position: 'middle',
                        journey_type: 'depart',
                    })
                    steps.push({
                        show_as: 'custom',
                        step: {
                            duration: {
                                value: 3600,
                            },
                            end_address: 'Attend appointment',
                            type: 'calendar',
                        },
                        position: 'middle',
                        journey_type: 'depart',
                    })
                } else if (this.showDepartStepsOffset === i && stepsToCollapse) {
                    steps.push({
                        show_as: 'collapse',
                        step: {
                            step_count: stepsToCollapse,
                            type: 'collapse',
                        },
                        position: 'middle',
                        journey_type: 'depart',
                    })
                } else {
                    steps.push({
                        show_as: 'hidden',
                        step,
                        position: 'middle',
                        journey_type: 'depart',
                    })
                }
            }

            const returnStepsLength = this.currentJourney.return.steps.length
            for (let i = 0; i < returnStepsLength; i += 1) {
                const step = this.currentJourney.return.steps[i]
                const stepsToCollapse = returnStepsLength - i - this.showReturnStepsOffset + 1
                const isLastStep = returnStepsLength === (i + 1)

                if (this.showReturnStepsOffset > i && !isLastStep) {
                    steps.push({
                        show_as: 'step',
                        step,
                        position: 'middle',
                        journey_type: 'return',
                    })
                } else if (isLastStep) {
                    steps.push({
                        show_as: 'step',
                        step,
                        position: 'middle',
                        journey_type: 'return',
                        last_step: true,
                    })
                    steps.push({
                        show_as: 'custom',
                        step: {
                            duration: {
                                value: 3600,
                            },
                            end_address: 'Return home',
                            type: 'house',
                        },
                        position: 'last',
                        journey_type: 'return',
                    })
                } else if (this.showReturnStepsOffset === i && stepsToCollapse) {
                    steps.push({
                        show_as: 'collapse',
                        step: {
                            step_count: stepsToCollapse,
                            type: 'collapse',
                        },
                        position: 'middle',
                        journey_type: 'return',
                    })
                }
            }

            return steps
        },
        // newCalculatedReturnTime(){
        //     // return moment(this.arrive).add(1, 'hours').format('YYYY/MM/DD HH:mm:ss');
        // }
    },
    methods: {
        ...mapActions([
            'retrieveSingleJourney',
            'updateReturnTime',
        ]),
        ...mapMutations(mutationsMapping),
        navigateStage(type) {
            if (type === 'forward') {
                let isNormalStage = false
                while (!isNormalStage) {
                    this.selectedStageIndex += 1
                    const nextStage = this.steps[this.selectedStageIndex]
                    if (nextStage.show_as === 'step') {
                        isNormalStage = true
                        this.selectedStage = nextStage
                    }
                }
            } else if (type === 'backwards') {
                let isNormalStage = false
                while (!isNormalStage) {
                    this.selectedStageIndex -= 1
                    const nextStage = this.steps[this.selectedStageIndex]
                    if (nextStage.show_as === 'step') {
                        isNormalStage = true
                        this.selectedStage = nextStage
                    }
                }
            }
        },
        showDetails(step, index) {
            window.scrollTo(0, 0)
            this.selectedStage = step
            this.selectedStageIndex = index
        },
        showJourney() {
            this.selectedStage = {}
            this.selectedStageIndex = null
        },
        resolveStepPosition(index) {
            return (index === this.currentJourney.return.steps.length - 1) ? 'last' : 'middle'
        },
        updateJourney() {
            // this.hasChanged = false
            const updatedTime = this.getUpdatedTime()
            this.clearResults()

            this.updateReturnTime({
                hash: this.$route.params.hash,
                params: { return_time: updatedTime },
                router: this.$router,
            })
        },
        getUpdatedTime() {
            /* arriveDateAndTime might not be available at page refresh - use return departure_at instead */
            const returnTime = this.arriveDateAndTime ? moment(this.arriveDateAndTime) : moment(this.currentJourney.return.departure_at, 'hh:mm')

            return returnTime.add(this.selectedTime.value, 'minutes').format('YYYY/MM/DD HH:mm:ss')
        },
        setSelected(value) {
            if (value.value === this.selectedTime.value) {
                this.selectedTime.disabled = true
                this.hasChanged = true
            } else {
                this.hasChanged = false
            }
        },
        showMap(type) {
            if (this.showingMap === type) {
                return true
            }
            return false
        },
        getMapButtonClass(type) {
            if (this.showingMap === type) {
                return 'btn-outline-primary'
            }

            return 'btn-outline-secondary'
        },
        getViewingButtonClass(type) {
            if (this.selected === type) {
                return 'btn-outline-primary'
            }

            return 'btn-outline-secondary'
        },
        showSteps(type) {
            if (type === 'depart') {
                this.showDepartStepsOffset = this.currentJourney.depart.steps.length + 1
            } else {
                this.showReturnStepsOffset = this.currentJourney.return.steps.length + 1
            }
        },
        scrollToElementMap() {
            this.selected = 'map'
            const el = this.$el.getElementsByClassName('map-of-journey')[0]

            if (el) {
                el.scrollIntoView()
            }
        },
        scrollToElementSteps() {
            this.selected = 'step-by-step'
            const el = this.$el.getElementsByClassName('steps-journey')[0]

            if (el) {
                el.scrollIntoView()
            }
        },
        scrollToJourneyDetails() {
            this.selected = 'details'
            const el = this.$el.getElementsByClassName('journey-details')[0]

            if (el) {
                el.scrollIntoView()
            }
        },
        handleScroll() {
            // if (window.scrollY < this.$refs.map.offsetTop) {
            //     this.selected = 'details'
            //     this.getViewingButtonClass()
            // } else if (window.scrollY > this.$refs.map.offsetTop && window.scrollY < this.$refs.stepByStep.offsetTop) {
            //     this.selected = 'map'
            //     this.getViewingButtonClass()
            // } else if (window.scrollY > this.$refs.stepByStep.offsetTop) {
            //     this.selected = 'step-by-step'
            //     this.getViewingButtonClass()
            // }
        },
    },
}
</script>
<style>
.scroll-offset{
    scroll-margin-top: 6rem
}
</style>
